import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent }        from './home.component';
import { NeedsComponent }       from './needs.component';
import { AwardsComponent }      from './awards.component';
import { SponsorsComponent }    from './sponsors.component';
import { ContactComponent }     from './contact.component';
import { CardsComponent }       from './cards.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home',     component: HomeComponent },
  { path: 'needs',    component: NeedsComponent },
  { path: 'awards',   component: AwardsComponent },
  { path: 'sponsors', component: SponsorsComponent },
  { path: 'contact',  component: ContactComponent },
  { path: 'cards',    component: CardsComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts